import { useQuery } from "@apollo/client";
import { compact } from "lodash";

import {
    EpcSummariesQuery,
    EpcSummariesQueryVariables,
} from "graphql-types/graphql";

import { GET_EPC_SUMMARY } from "./use-epc-summary.query";

export const useEpcSummaryQuery = (bfe: string) => {
    const { data, loading } = useQuery<
        EpcSummariesQuery,
        EpcSummariesQueryVariables
    >(GET_EPC_SUMMARY, {
        variables: { bfes: [bfe] },
        skip: !bfe,
        fetchPolicy: "cache-first",
    });

    const summaries = compact(data?.getEpcSummaries);

    return {
        data: summaries,
        loading,
    };
};
